export enum AIAnalyzeActions {
  CHEST_XRAY = 'CHEST_XRAY',
  MAMMOGRAPHY = 'MAMMOGRAPHY',
  BRAIN_CT = 'BRAIN_CT',
  LUNG_CT = 'LUNG_CT',
  LIVER_CT = 'LIVER_CT',
  BRAIN_MRI = 'BRAIN_MRI',
  SPINE_XR = 'SPINE_XR',
}

export enum AI_MODEL {
  CHEST_XRAY = 'chestxray',
  MAMMOGRAPHY = 'mammogram',
  LUNG_CT = 'lungct',
  LIVER_CT = 'liverct',
  BRAIN_MRI = 'brainmri',
  BRAIN_CT = 'brainct',
  SPINE_XR = 'spinexr',
}

export const AIAnalyzeList = Object.freeze([
  {
    name: 'Chest X-ray',
    action: AIAnalyzeActions.CHEST_XRAY,
    active: true,
    key: AI_MODEL.CHEST_XRAY,
  },
  {
    name: 'Spine XR',
    action: AIAnalyzeActions.SPINE_XR,
    active: true,
    key: AI_MODEL.SPINE_XR,
  },
  {
    name: 'Mammography',
    action: AIAnalyzeActions.MAMMOGRAPHY,
    active: true,
    key: AI_MODEL.MAMMOGRAPHY,
  },
  {
    name: 'Lung CT',
    action: AIAnalyzeActions.LUNG_CT,
    active: true,
    key: AI_MODEL.LUNG_CT,
  },
  {
    name: 'Liver CT',
    action: AIAnalyzeActions.LIVER_CT,
    active: true,
    key: AI_MODEL.LIVER_CT,
  },
  {
    name: 'Brain CT',
    action: AIAnalyzeActions.BRAIN_CT,
    active: true,
    key: AI_MODEL.BRAIN_CT,
  },
  {
    name: 'Brain MRI',
    action: AIAnalyzeActions.BRAIN_MRI,
    active: true,
    key: AI_MODEL.BRAIN_MRI,
  },
]);

export enum BODY_PARTS {
  CHEST = 'CHEST',
  BREAST = 'BREAST',
  LUNG = 'LUNG',
}

export enum SPECIAL_CONCLUSIONS {
  NOT_AVAILABLE = 'N/A',
  NO_FINDING = 'NO FINDING',
  NO_CONCLUSION = 'N/C',
  NEED_FURTHER_INVESTIGATIONS = 'NFI',
}

export enum FEEDBACK_STATUS {
  LIKE = 'LIKE',
  DISLIKE = 'DISLIKE',
  NOTE = 'NOTE',
}

export enum FEEDBACK_ACTIONS {
  RATING = 'RATING',
  COMMENT = 'COMMENT',
  VIEW_MORE = 'VIEW_MORE',
  VIEWER_OPEN = 'VIEWER_OPEN',
}

export const MAMMO_GLOBAL_KEY = Object.freeze(['BIRADS', 'DENSITY']);

export const SEGMENT_DEFAULT_INDEX = 10;

export enum AI_RESULT_SCOPES {
  GLOBAL = 'GLOBAL',
  LOCAL = 'LOCAL',
}

export const VINDR_AI_SCOPES = Object.freeze({
  SERIES_SCOPE: ['brainct', 'liverct', 'brainmri', 'lungct'],
  STUDY_SCOPE: ['mammogram'],
  INSTANCE_SCOPE: ['chestxray', 'spinexr'],
});

export const VINDR_AI_SEGMENT_SUPPORT = Object.freeze(['brainct']);
